import { Preset } from "@openng/optimus-ui-themes/types";
import { GuiUtils } from "src/modules/utils/misc/gui-utils";
import { FrontendCorporateIdentity } from "src/modules/sm-base/shared/FrontendCorporateIdentity";

export class CorporateIdentityTools {

    static getPrimePreset(ci: FrontendCorporateIdentity): Preset {
        return {
            semantic: {
                primary: GuiUtils.buildColorScale(ci.primaryColor)
            },
            extend: {
                app: {
                    topbar: {
                        bgColor: ci.topbarBgColor,
                        bgDarkColor: ci.topbarBgColorDark
                    },
                    topbarLogo: {
                        bgColor: ci.topbarLogoBgColor,
                        height: ci.topbarLogoHeight,
                        padding: ci.topbarLogoPadding
                    },
                    login: {
                        logoBackgroundColor: ci.loginLogoBackgroundColor,
                        logoPadding: ci.loginLogoPadding
                    },
                    primaryColor: ci.primaryColor,
                    primaryTextColor: ci.primaryTextColor
                }
            },
            css: ({ dt }) => `
                :root {
                   --p-form-field-border-radius: 4px;
                   --topbar-bg: ${dt('app.topbar.bgColor')};
                   --topbar-bg-dark: ${dt('app.topbar.bgDarkColor')};
                   --primary-color: ${dt('app.primaryColor')};
                   --primary-text-color: ${dt('app.primaryTextColor')};
                   --p-card-border-radius: var(--p-border-radius-md) !important
                }

                .p-checkbox {
                  height: unset !important;
                }

                .login-panel img {
                    padding: ${dt('app.login.logoPadding')};
                    background-color: ${dt('app.login.logoBackgroundColor')};
                }

                .topbar-logo-img {
                    background-color: ${dt('app.topbarLogo.bgColor')};
                    height: ${dt('app.topbarLogo.height')};
                    padding: ${dt('app.topbarLogo.padding')};
                }
            `
        };
    }
}